import React, { useState, useEffect } from 'react';
import { BaseButton } from '@repo/common';

import { ReactComponent as ArrowBottomIcon } from '@repo/common/assets/icons/20px/icon_20px_arrow-bottom.svg';
import { ReactComponent as ArrowTopIcon } from '@repo/common/assets/icons/20px/icon_20px_arrow-top.svg';

const MobileSortFilter = ({ onChange, filterState, isSearchPage = false }) => {
  const [isSortOpen, setIsSortOpen] = useState(false);

  const sortOptions = ['By Date', 'By Completion'];
  const initialSort = sortOptions.includes(filterState)
    ? filterState
    : sortOptions[0];
  const [selectedOption, setSelectedOption] = useState(initialSort);

  useEffect(() => {
    setSelectedOption(filterState);
  }, [filterState]);

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    onChange(option);
    setIsSortOpen(false);
  };

  return (
    <div className={`flex flex-col justify-center items-center relative`}>
      <div className='px-4 py-3 flex justify-center items-center w-full'>
        <BaseButton
          type='text'
          iconPosition='after'
          icon={isSortOpen ? <ArrowTopIcon /> : <ArrowBottomIcon />}
          bgclass='bg-transparent border-none'
          hoverclass='hover:text-grayscale-gray07'
          activeclass='active:bg-grayscale-gray01 active:border-none active:text-grayscale-gray07'
          onClick={() => setIsSortOpen((prev) => !prev)}
        >
          {selectedOption}
        </BaseButton>
      </div>

      {isSortOpen && (
        <div
          className={`flex flex-col justify-center items-center px-4 pb-4 w-full`}
        >
          {sortOptions.map((option) => (
            <BaseButton
              key={option}
              type='text'
              hideIcon
              bgclass='bg-transparent'
              hoverclass='hover:bg-grayscale-gray02 hover:text-grayscale-gray07'
              activeclass='active:bg-grayscale-gray02 active:text-grayscale-gray07'
              width='100%'
              onClick={() => handleOptionClick(option)}
            >
              {option}
            </BaseButton>
          ))}
        </div>
      )}
    </div>
  );
};

export default MobileSortFilter;
